// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2538":"c8e26dd5","3247":"02f942a2"}[chunkId] || chunkId) + "." + {"128":"89a18656d2ee66bb","2538":"59df9462b38dcc5f","3247":"c281bc2a8ac84cc7","7911":"7bd8d978cfee7d84"}[chunkId] + ".js";
};